
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[city]/personal/na-pokupku-doma",
      function () {
        return require("private-next-pages/[city]/personal/na-pokupku-doma.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[city]/personal/na-pokupku-doma"])
      });
    }
  